export const targetSuppliersFilterFields = ['name'];

export const targetSuppliersSelectLabel = object =>
  `${object.name} - ${object.creditorNumber}`;
